import React from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {makeStyles} from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";

const useStyles = makeStyles((theme) => ({
    accordionSummary: {
        fontSize: 16,
        fontWeight: 300,
        '&:hover, &:focus': {
            backgroundColor:  grey[200],
        },
    },
    expanded: {
        backgroundColor: grey[200],
        fontWeight: 700,
    },
    accordionDetails: {
        backgroundColor: grey[50],
    },
}));

const FAQAccordion = ({title, children}) => {
    const classes = useStyles();

    return (
        <Accordion>
            <AccordionSummary
                classes={{root: classes.accordionSummary, expanded: classes.expanded}}
                expandIcon={<ExpandMoreIcon/>}
            >
                {title}
            </AccordionSummary>
            <AccordionDetails>
                <div className="flex flex-col">
                    {children}
                </div>
            </AccordionDetails>
        </Accordion>
    )
}

export default FAQAccordion;